module.exports = __webpack_public_path__ + "img/honor1.c29d1c75.png";